import { DirectiveBinding } from "vue";

interface CustomHTMLElement extends HTMLElement {
    clickOutsideEvent: (event: Event) => void;
}

export default {
    beforeMount: (el: CustomHTMLElement, binding: DirectiveBinding) => {
        el.clickOutsideEvent = (event: Event) => {
            if (!event.target) {
                return;
            }
            // here I check that click was outside the el and his children
            if (!(el == event.target || el.contains(event.target as Node))) {
                // and if it did, call method provided in attribute value
                binding.value();
            }
        };
        document.addEventListener("click", el.clickOutsideEvent);
    },
    unmounted: (el: CustomHTMLElement) => {
        document.removeEventListener("click", el.clickOutsideEvent);
    },
};
